import { render, staticRenderFns } from "./grade-accelerate.vue?vue&type=template&id=6d76f0dc"
import script from "./grade-accelerate.vue?vue&type=script&lang=js"
export * from "./grade-accelerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports